import { batch } from "react-redux";
// Import needed actions from other actio files
import {
  fetchSetDz,
  setSampleProcessing,
  setSampleValueDisplay,
  updateSamplesDoneFlag,
  fetchSwsValueAndVelocitySlicePlot,
  increaseSamplesAcquired,
  setSampleSelectable,
  increaseSamplesProcessed,
  userToggleSampleIncluded,
  setSampleData,
  fetchSaveStudy,
  calculateStudyProgress,
  checkAutoAdvance,
  setSelectedSample,
  setFocusElement,
  setLastViewedSample,
  openResultSnackbar,
  updateSampleAlert,
  selectSample,
  warningResponse,
  fetchBmodePlot,
  fetchSwsPlotAndVelocitySlicePlot,
  fetchSwsPlot,
  updateSamplesSavedFlag,
  setSampleDataSaved,
  getLocationZandDzValues,
} from "../actions";

import { defaultPercentSliceWidth, csiTypes } from "../constants/constants";

export const SET_SWS_RANGE = "SET_SWS_RANGE";
export function setSwsRange(id, swsRange) {
  return {
    type: SET_SWS_RANGE,
    id: id,
    swsRange: swsRange,
  };
}

export const SET_B_RANGE = "SET_B_RANGE";
export function setBRange(id, bRange) {
  return {
    type: SET_B_RANGE,
    id: id,
    bRange: bRange,
  };
}
export const SET_ACQUIRING = "SET_ACQUIRING";
export function setAcquiring(status) {
  return {
    type: SET_ACQUIRING,
    status: status,
  };
}

export const SET_Z_VALUE = "SET_Z_VALUE";
export function setZValue(zValue, id) {
  return {
    type: SET_Z_VALUE,
    id: id,
    zValue: zValue,
  };
}

export const SET_DZ = "SET_DZ";
export function setDz(sampleId, dz) {
  return {
    type: SET_DZ,
    id: sampleId,
    dz: dz,
  };
}

export const SET_ROI_PERCENTAGE_SLICE = "SET_ROI_PERCENTAGE_SLICE";
export function setRoiPercentageSlice(sampleId, percentage) {
  return {
    type: SET_ROI_PERCENTAGE_SLICE,
    id: sampleId,
    percentSliceWidth: percentage,
  };
}

export const SET_V_MAX = "SET_V_MAX";
export function setVMax(sampleId, vMax) {
  return {
    type: SET_V_MAX,
    id: sampleId,
    vMax: vMax,
  };
}

export const SET_BMODE_THICKNESS = "SET_BMODE_THICKNESS";
export function setBmodeThickness(top, bottom, id) {
  return {
    type: SET_BMODE_THICKNESS,
    id,
    top,
    bottom,
  };
}

export const SET_LOCATION_WIDE_ROI_REFERENCE =
  "SET_LOCATION_WIDE_ROI_REFERENCE";
export function setLocationWideRoiReference(sampleId, locationId, sampleType) {
  return {
    type: SET_LOCATION_WIDE_ROI_REFERENCE,
    sampleId,
    locationId,
    sampleType,
  };
}

export const SET_DEFAULT_ROI_REFERENCE = "SET_DEFAULT_ROI_REFERENCE";
export function setDefaultRoiReference(sampleId, locationId) {
  return {
    type: SET_DEFAULT_ROI_REFERENCE,
    sampleId,
    locationId,
  };
}

export const SET_PICTURE_IMAGE = "SET_PICTURE_IMAGE";
export function setPictureImage(uuid, data) {
  return {
    type: SET_PICTURE_IMAGE,
    id: uuid,
    data,
  };
}

// update the SWS and standard deviation for a location
export const SET_AVERAGE_SHEAR_WAVE_SPEED = "SET_AVERAGE_SHEAR_WAVE_SPEED";
export function setAverageShearWaveSpeed(
  locationId,
  newShearWaveSpeed,
  newStandardDev
) {
  return {
    type: SET_AVERAGE_SHEAR_WAVE_SPEED,
    locationId: locationId,
    newShearWaveSpeed: newShearWaveSpeed,
    newStandardDev: newStandardDev,
  };
}

export const SET_AVERAGE_THICKNESS = "SET_AVERAGE_THICKNESS";
export function setAverageThickness(locationId, newThickness, newStandardDev) {
  return {
    type: SET_AVERAGE_THICKNESS,
    locationId,
    newThickness,
    newStandardDev,
  };
}

export const SET_CAMERA_MODAL = "SET_CAMERA_MODAL";
export function setCameraModal(status, id) {
  return {
    type: SET_CAMERA_MODAL,
    status,
    id,
  };
}

// Acquisition Completed=> Server finished acquisition
export function receiveAcquisitionComplete(data) {
  return (dispatch, getState) => {
    let state = getState();
    const locId = state.samples.byId[data["uuid"]].locationId;
    let acqType;
    if (data["type"] === "BMODE") {
      acqType = "BMODE";
    } else if (data["type"] === "PICTURE") {
      acqType = "PICTURE";
    } else {
      acqType = "CSI";
    }
    batch(() => {
      dispatch(updateSamplesDoneFlag());
      dispatch(
        increaseSamplesAcquired(locId, acqType, state.protocol.acq_types)
      );
    });
    batch(() => {
      dispatch(calculateStudyProgress());
      if (acqType !== "PICTURE") {
        dispatch(checkAutoAdvance());
      }
    });
  };
}

// Receive sample acquisition data from the server. Based on acquisition type, add the data to redux and update the app.
export function receiveSampleData(data) {
  return (dispatch, getState) => {
    // Create const for some state variables.
    let state = getState();
    const sample = state.samples.byId[data["uuid"]];
    const locId = sample.locationId;
    const location = state.locations.byId[locId];

    if (sample.type !== "BMODE") {
      //If there is a roiReference for the location then use the roiReference percentage, if not the default percentage value is 50
      const roiReference = location.roiReference;
      if (
        roiReference.locationWide.id !== null &&
        csiTypes.includes(roiReference.locationWide.type)
      ) {
        // Using CSI  as roi reference
        data.percentSliceWidth =
          state.samples.byId[roiReference.locationWide.id].percentSliceWidth;
      } else {
        data.percentSliceWidth = defaultPercentSliceWidth;
      }
    }

    // Switch based on sample type
    switch (sample.type) {
      case "BMODE":
        batch(() => {
          dispatch(setSampleData(data)); // Add Bmode data to sample redux state
          dispatch(increaseSamplesProcessed(locId, sample.type));
          if (!state.utility.showAutoAdvancePopup) {
            dispatch(openResultSnackbar(data["thickness"], "BMODE"));
          }
          dispatch(updateSampleAlert(data["uuid"], data["alert"])); // Update sample and location alert as needed
          // If the data has an alert=true then it should be excluded from the study by default. The user can choose to include it back in the study
          if (data["alert"]["status"] === true && sample.includeInStudy) {
            dispatch(userToggleSampleIncluded(data["uuid"]));
          }
          if (locId === state.locations.selectedLocationId) {
            dispatch(selectSample(data["uuid"])); // handle sample selection
          }
          // Set the new default roi range if there is not a locationWide roi reference.
          if (location.roiReference.locationWide.id === null) {
            dispatch(
              updateDefaultRoiReference(
                data["uuid"],
                locId,
                data["z_val"],
                data["thickness"]
              )
            );
          } else {
            let locationRoi = getLocationZandDzValues(state);
            dispatch(fetchSetDz(locationRoi.dz, locationRoi.z));
          }
        });

        dispatch(updateSamplesDoneFlag());
        dispatch(calculateThickness(data["uuid"]));
        dispatch(fetchSaveStudy("AUTOSAVE", state.studyInfo.encryption)); // Only B-mode is autosave at this point. Other types have more data coming in such as image stacks/sws estimates
        break;
      default:
        batch(() => {
          dispatch(setSampleData(data));
          dispatch(increaseSamplesProcessed(locId, sample.type));
          if (!state.utility.showAutoAdvancePopup) {
            dispatch(openResultSnackbar(data["sws_value"], "CSI"));
          }
          dispatch(updateSampleAlert(data["uuid"], data["alert"]));

          if (data["alert"]["status"] === true && sample.includeInStudy) {
            dispatch(userToggleSampleIncluded(data["uuid"]));
          }
          // If the data has an alert=true then it should be excluded from the study by default. The user can choose to include it back in the study
          if (locId === state.locations.selectedLocationId) {
            dispatch(selectSample(data["uuid"]));
          }
        });

        dispatch(checkNullSwsSelection(data["uuid"], data["sws"]));
        dispatch(updateSamplesDoneFlag());
        dispatch(calculateShearWaveSpeed(data["uuid"]));
        dispatch(fetchSaveStudy("AUTOSAVE", state.studyInfo.encryption)); //Autosave after all SWS data is received
        break;
    }
    dispatch(setAcquiring(false));
  };
}

export function calculateShearWaveSpeed(sampleId) {
  return (dispatch, getState) => {
    let state = getState();
    let locId = state.samples.byId[sampleId].locationId;
    const acqType = "CSI"; // shearwave is calculated only for CSI
    const location = state.locations.byId[locId];

    // only if enough samples have been included and processed AND there isnt a sample thats still processing
    if (
      location.samplesAcquired[acqType] !== 0 //dont try to calculate if no sample (if samplesNeeded is zero it causes problems)
    ) {
      // make new array of only included samples
      let includedSamples = [];
      let totalSpeed = 0;
      let nullSwsIncluded = false;

      // take average of all (included) samples
      for (let i = 0; i < location.samples.length; i++) {
        let sampleId = location.samples[i];
        let sample = state.samples.byId[sampleId];
        if (
          sample.includeInStudy &&
          sample.type !== "BMODE" &&
          sample.type !== "PICTURE"
        ) {
          includedSamples.push(sample.shearWaveSpeed);
          totalSpeed += sample.shearWaveSpeed;
          if (sample.shearWaveSpeed === null) {
            nullSwsIncluded = true;
          }
        }
      }
      if (nullSwsIncluded) {
        dispatch(setAverageShearWaveSpeed(locId, null, null));
      } else {
        // there needs to be at least one included sample to calculate the averade
        const meanSWS = totalSpeed / location.samplesAcquired[acqType];

        const standardDeviation = (numbersArray) => {
          return Math.sqrt(
            numbersArray
              .map((x) => Math.pow(x - meanSWS, 2))
              .reduce((a, b) => a + b) / numbersArray.length
          );
        };
        const newStandardDev = standardDeviation(includedSamples);
        dispatch(setAverageShearWaveSpeed(locId, meanSWS, newStandardDev));
      }
    } else {
      // No samples are taken OR all samples are excluded from study so thickness should be set to null
      dispatch(setAverageShearWaveSpeed(locId, null, null));
    }
  };
}

export function calculateThickness(sampleId) {
  return (dispatch, getState) => {
    let state = getState();
    let locId = state.samples.byId[sampleId].locationId;
    const acqType = "BMODE";
    const location = state.locations.byId[locId];
    // only if enough samples have been included and processed
    if (
      location.samplesAcquired[acqType] !== 0 //dont try to calculate if no sample (if samplesNeeded is zero it causes problems)
    ) {
      // make new array of only included samples
      let includedSamples = [];
      let totalThickness = 0;

      // take average of all (included) samples
      for (let i = 0; i < location.samples.length; i++) {
        let sampleId = location.samples[i];
        let sample = state.samples.byId[sampleId];
        if (sample.includeInStudy && sample.type === "BMODE") {
          includedSamples.push(sample.thickness);
          totalThickness += sample.thickness;
        }
      }

      // There needs to be at least one included sample to take an average
      // if (includedSamples.length !== 0) {
      const meanThickness = totalThickness / location.samplesAcquired[acqType];
      const standardDeviation = (numbersArray) => {
        return Math.sqrt(
          numbersArray
            .map((x) => Math.pow(x - meanThickness, 2))
            .reduce((a, b) => a + b) / numbersArray.length
        );
      };

      const newStandardDev = standardDeviation(includedSamples);
      dispatch(setAverageThickness(locId, meanThickness, newStandardDev));
    } else {
      // No samples are taken OR all samples are excluded from study so thickness should be set to null
      dispatch(setAverageThickness(locId, null, null));
    }
  };
}

export function requestPicture(sampleId) {
  return (dispatch) => {
    dispatch(setCameraModal(true, sampleId));
    dispatch(setSampleSelectable(sampleId, true));
    dispatch(setSampleProcessing(sampleId, true));
    dispatch(updateSamplesDoneFlag());
    dispatch(setSelectedSample(sampleId));
    dispatch(setFocusElement(sampleId));
  };
}

export function receivePicture(sampleId, data) {
  return (dispatch, getState) => {
    let state = getState();
    const locId = state.samples.byId[sampleId].locationId;

    dispatch(setCameraModal(false, sampleId));
    batch(() => {
      dispatch(setPictureImage(sampleId, data));
      dispatch(setLastViewedSample(locId, sampleId));
      dispatch(increaseSamplesProcessed(locId, "PICTURE"));
      dispatch(setSampleProcessing(sampleId, false));
      dispatch(setSampleValueDisplay(sampleId, true));
      dispatch(setSampleDataSaved(sampleId, true));
    });
    dispatch(updateSamplesDoneFlag());
    dispatch(updateSamplesSavedFlag());
    dispatch(calculateStudyProgress());
    dispatch(checkAutoAdvance());
    dispatch(fetchSaveStudy("AUTOSAVE", state.studyInfo.encryption));
  };
}

//Check if the SWS is null for the current zIndex. If so, then sample is labelled as alert
export function checkNullSwsSelection(sampleId, swsValue) {
  return (dispatch) => {
    const message = "SWS is not valid at the chosen depth";
    if (swsValue === null) {
      dispatch(
        updateSampleAlert(sampleId, {
          status: true,
          type: "SWS",
          message: "Elasticity value could not be calculated.",
        })
      );
      dispatch(warningResponse(message));
    } else {
      dispatch(
        updateSampleAlert(sampleId, {
          status: false,
          type: "SWS",
          message: "Elasticity value could not be calculated.",
        })
      );
    }
  };
}

export function updateDefaultRoiReference(sampleId, locationId, z, thickness) {
  return (dispatch) => {
    if (sampleId === null) {
      dispatch(setDefaultRoiReference(null, locationId));
      dispatch(fetchSetDz(null, null));
    } else {
      let newDz = thickness * (defaultPercentSliceWidth / 100); // Adjust dx based on percent slice width
      batch(() => {
        dispatch(setDefaultRoiReference(sampleId, locationId));
        dispatch(fetchSetDz(newDz, z));
      });
    }
  };
}

export function updateLocationWideRoiReference(sampleId, locationId) {
  return (dispatch, getState) => {
    let state = getState();
    const sampleById = state.samples.byId;
    const newRoiSample = state.samples.byId[sampleId];
    const locationSamples = state.locations.byId[locationId].samples;

    // Array of samples ids that should fetch new SWS value for the new ROI region
    let roiUpdateSamples = [];
    for (let sampleCsiId of locationSamples) {
      if (
        csiTypes.includes(sampleById[sampleCsiId].type) &&
        sampleById[sampleCsiId].includeInStudy &&
        sampleCsiId !== sampleId
      ) {
        roiUpdateSamples.push(sampleCsiId);
      }
    }
    // Case 1: User unchecked location wide ROI reference. Reset the location wide ROI reference
    if (sampleId === null) {
      batch(() => {
        dispatch(setLocationWideRoiReference(null, locationId, null));
        // Revert to using default reference if one exists
        if (state.locations.byId[locationId].roiReference.default === null) {
          // dispatch(fetchSetDz(null, null));
        } else {
          dispatch(
            fetchSetDz(
              sampleById[state.locations.byId[locationId].roiReference.default]
                .thickness *
                (defaultPercentSliceWidth / 100),
              sampleById[state.locations.byId[locationId].roiReference.default]
                .zValue
            )
          );
        }
      });

      // Case 2: User set a BMODE sample as a location wide roi reference
    } else if (newRoiSample.type === "BMODE") {
      const newRoiZ = newRoiSample.zValue;
      const newDz = newRoiSample.thickness;

      // Request SWS for every applicable sample
      for (let sample of roiUpdateSamples) {
        //Find the closest z-value to the b-mode thickness position
        // let zList = sampleById[sample].zList;
        let zList = Array(sampleById[sample].zList.nz)
          .fill()
          .map(
            (_, idx) =>
              sampleById[sample].zList.z0 + sampleById[sample].zList.inc * idx
          );
        var closestZ = zList.reduce((prev, curr) => {
          return Math.abs(curr - newRoiZ) < Math.abs(prev - newRoiZ)
            ? curr
            : prev;
        });
        dispatch(setZValue(closestZ, sample));
        dispatch(setRoiPercentageSlice(sample, defaultPercentSliceWidth)); //default percentSlideWidth is 50
        dispatch(setDz(sample, newDz)); //change the dz value for the sample in sampleReducer
        dispatch(fetchSwsValueAndVelocitySlicePlot(sample));
      }
      // Set ROI on redux and back-end
      batch(() => {
        dispatch(
          setLocationWideRoiReference(sampleId, locationId, newRoiSample.type)
        ); //Update the roiReference sample for the location in locationsReducer
        dispatch(
          updateDefaultRoiReference(sampleId, locationId, newRoiZ, newDz)
        ); //change the dz value in the back-end server
      });

      // Case 3: User set a CSI sample as a location wide roi reference
    } else {
      //A CSI sample is selected as reference
      const newRoiZ = newRoiSample.zValue;
      const newDz = newRoiSample.dz;
      const newPercentSliceWidth = newRoiSample.percentSliceWidth;

      // Request SWS for every applicable sample
      for (let sample of roiUpdateSamples) {
        dispatch(setZValue(newRoiZ, sample));
        dispatch(setRoiPercentageSlice(sample, newPercentSliceWidth));
        dispatch(setDz(sample, newDz));
        dispatch(fetchSwsValueAndVelocitySlicePlot(sample));
      }
      batch(() => {
        dispatch(
          setLocationWideRoiReference(sampleId, locationId, newRoiSample.type)
        ); //Update the roiReference sample for the location in locationsReducer
        // dispatch(fetchSetDz(sampleById[sampleId].roiDz, newRoiZ));
      });
    }
  };
}

export function changeGlobalBmodeColorbar(bmodeColorRange) {
  return (dispatch, getState) => {
    let state = getState();
    let bmodeSampleIds = state.samples.idByType["BMODE"];
    let samplesByid = state.samples.byId;
    for (let sampleId of bmodeSampleIds) {
      if (
        samplesByid[sampleId].colorBar.range !== bmodeColorRange &&
        samplesByid[sampleId].includeInStudy
      ) {
        dispatch(fetchBmodePlot(sampleId, bmodeColorRange));
      }
    }
  };
}

export function changeGlobalVelocityColorbarChange(vMax) {
  return (dispatch, getState) => {
    let state = getState();
    let csiSampleIds = state.samples.idByType["CSI"];
    let samplesByid = state.samples.byId;
    for (let sampleId of csiSampleIds) {
      if (
        samplesByid[sampleId].type !== "SINGLE" &&
        samplesByid[sampleId].velocitySlicePlot.colorBar.range[1] !== vMax &&
        samplesByid[sampleId].includeInStudy &&
        !samplesByid[sampleId].alert.state
      ) {
        dispatch(setVMax(sampleId, vMax));
        dispatch(fetchSwsValueAndVelocitySlicePlot(sampleId));
      }
    }
  };
}

export function changeGlobalSwsColorbarChange(swsColorRange) {
  return (dispatch, getState) => {
    let state = getState();
    let csiSampleIds = state.samples.idByType["CSI"];
    let samplesByid = state.samples.byId;
    for (let sampleId of csiSampleIds) {
      if (
        [
          Math.round(samplesByid[sampleId].swsPlot.colorBar.yAxis.range[0]),
          Math.round(samplesByid[sampleId].swsPlot.colorBar.yAxis.range[1]),
        ] !== swsColorRange &&
        samplesByid[sampleId].includeInStudy &&
        !samplesByid[sampleId].alert.state
      ) {
        dispatch(fetchSwsPlotAndVelocitySlicePlot(sampleId, swsColorRange));
      }
    }
  };
}
